export interface Project {
  id: number;
  title: string;
  author: string;
  authorAvatar: string;
  date: string;
  budget: string;
  category: string;
}

export const featuredProjects: Project[] = [
  {
    id: 9293,
    title: "Delete instagram account",
    author: "Samsann",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "December 20, 2025",
    budget: "$500.00",
    category: "Social Media Hack",
  },
  {
    id: 9283,
    title: "Identity search based on a phone number",
    author: "tsgeopar",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "December 11, 2025",
    budget: "$500.00",
    category: "Spy",
  },
  {
    id: 9384,
    title: "Cracking Software",
    author: "DaQu",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "December 5, 2025",
    budget: "$500.00",
    category: "Blackhat Hacking",
  },
  {
    id: 9229,
    title: "Penetration Testing",
    author: "one",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "November 25, 2025",
    budget: "$5,000.00",
    category: "Penetration Testing",
  },
  {
    id: 9175,
    title: "Changing university grade",
    author: "Sketchy_lilx",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "October 24, 2025",
    budget: "$500.00",
    category: "Blackhat Hacking",
  },
  {
    id: 9214,
    title: "Hack bot of telegram",
    author: "minaax",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "October 21, 2025",
    budget: "$500.00",
    category: "Social Media Hack",
  },
  {
    id: 9173,
    title: "Cheating psychopath girlfriend",
    author: "Blacky000",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "September 23, 2025",
    budget: "$1,000.00",
    category: "Blackhat Hacking",
  },
  {
    id: 9157,
    title: "追回平台扣留的资金",
    author: "XIAO900624",
    authorAvatar: "https://hackerslodge.com/wp-content/uploads/2026/01/user-150x150-1.png",
    date: "August 6, 2025",
    budget: "$1,500.00",
    category: "Social Media Hack",
  },
];